import universal from 'react-universal-component';

import horoscopeActions from 'store/horoscope/actions';
import signActions from 'store/sign/actions';
import timeframeActions from 'store/timeframe/actions';
import categoryActions from 'store/category/actions';
import { getToday, convertDate } from 'utils';

import { LoadingSpinner, ghost } from '@minerva-analytics/pantheon';
import { GHOST_API } from './constants';


const AsyncLegal = universal(import(`views/Legal`), {
  loading: LoadingSpinner,
});

const AsyncHome = universal(import(`views/Home`), {
  loading: LoadingSpinner,
});

const AsyncSign = universal(import(`views/SignPage`), {
  loading: LoadingSpinner,
});

const AsyncConfirm = universal(import(`views/ConfirmPage`), {
  loading: LoadingSpinner,
});

const AsyncAbout = universal(import(`views/About`), {
  loading: LoadingSpinner,
});

const AsyncCompatibility = universal(import(`views/Compatibility`), {
  loading: LoadingSpinner,
});

const AsyncArticle = universal(import(`views/Article`), {
  loading: LoadingSpinner,
});

const AsyncArticles = universal(import(`views/Articles`), {
  loading: LoadingSpinner,
});

const AsyncLandingPage = universal(import(`views/LandingPage`), {
  loading: LoadingSpinner,
});

const { getArticle, selectArticle } = ghost.actions;

export default [
  {
    path: `/signup`,
    exact: true,
    component: AsyncLandingPage,
    loadData: () => {},
  },
  {
    path: `/articles/:slug`,
    component: AsyncArticle,
    loadData: async (store, match) => {
      const { slug } = match.params;
      store.dispatch(selectArticle(slug));
      await store.dispatch(getArticle(GHOST_API, slug));
    },
  },
  {
    path: `/articles`,
    component: AsyncArticles,
    exact: true,
  },
  {
    path: `/about`,
    component: AsyncAbout,
    exact: true,
  },
  {
    path: `/compatibility-calculator`,
    component: AsyncCompatibility,
    exact: true,
  },
  {
    path: `/privacy`,
    component: AsyncLegal,
    exact: true,
    loadData: () => {},
  },
  {
    path: `/terms`,
    component: AsyncLegal,
    exact: true,
    loadData: () => {},
  },
  {
    path: `/cookie`,
    component: AsyncLegal,
    exact: true,
    loadData: () => {},
  },
  {
    path: `/ccpa`,
    component: AsyncLegal,
    exact: true,
    loadData: () => {},
  },
  {
    path: `/:category`,
    component: AsyncHome,
    exact: true,
    loadData: () => {},
  },
  {
    path: `/confirm/:id/:token`,
    key: `/confirm`,
    component: AsyncConfirm,
    loadData: () => {},
  },
  {
    path: `/:category/:timeframe/:sign`,
    component: AsyncSign,
    loadData: async (store, match) => {
      await store.dispatch(horoscopeActions.getHoroscope({
        params: {
          ...match.params,
          date: convertDate(getToday()),
        },
      }));
      store.dispatch(categoryActions.selectCategory({ id: match.params.category }));
      store.dispatch(timeframeActions.selectTimeframe({ id: match.params.timeframe }));
      store.dispatch(signActions.selectSign({ id: match.params.sign }));
    },
  },
  {
    path: `/`,
    exact: true,
    component: AsyncHome,
    loadData: () => {},
  },
];
